package com.clany.backoffice.data.network

import kotlin.native.concurrent.ThreadLocal

/**
 * Configuration object for Keycloak and API settings.
 * Modify these values to point to your specific environment.
 */
@ThreadLocal
object KeycloakConfig {
    // API Configuration
    val API_URL: String = com.ragnorak.clanybackoffice.BuildConfig.API_URL
    
    // Keycloak Configuration
    // These values are now read from BuildConfig (generated from local.properties)
    val AUTH_URL: String = com.ragnorak.clanybackoffice.BuildConfig.AUTH_URL
    val REALM: String = com.ragnorak.clanybackoffice.BuildConfig.REALM
    val CLIENT_ID: String = com.ragnorak.clanybackoffice.BuildConfig.CLIENT_ID
}
